import { cloneDeep } from 'lodash';
import questionTypes from '../questionTypes';

import getCommonBlockProps from './getCommonBlockProps';
import { STYLING_KEY_QUESTION_TEXT } from '../../constants/stylingKey';
import backButtonConfig from './backButton';
import generateClientUuid from '../../utils/generateClientUuid';
import buttonBlockToFormInitialValues from './buttonBlockToFormInitialValues';

export default {
  type: questionTypes.submitButton,
  pickBlockPropsToInitialValues: buttonBlockToFormInitialValues,
  getDefaultProps: () => ({
    ...getCommonBlockProps(),
    backButton: {
      ...cloneDeep(backButtonConfig.getDefaultProps()),
      clientUuid: generateClientUuid(),
    },
    label: 'Submit',
    alignment: 'right',
  }),
  settings: {
    defaultStylingEntity: STYLING_KEY_QUESTION_TEXT,
    isRequiredField: () => true,
    isUniqueField: () => true,
    isTextRequired: () => false,
  },
};
